import CompletedBookings from '@commons/bookings/completed'
import React from 'react'

const ProviderCompletedBookings = ({ user }) => {
  return <CompletedBookings user={user} />
}

export default ProviderCompletedBookings
